import { LOCK_VPN_PAGE_PATH } from 'application/consts';
import LockVpnPageWrapper from 'application/pages/LockVpnPage';
import CleanLayout from 'application/layout/CleanLayout';

import { RouteConfig } from '..';

export const lockVpnRoutes: RouteConfig[] = [
  {
    element: <CleanLayout />,
    children: [
      {
        path: LOCK_VPN_PAGE_PATH,
        element: <LockVpnPageWrapper />,
      },
    ],
  },
];
